class Dynamic_Shop {
    static path = 'variables/dynamic-shop';

    constructor(mutator) {
        this.addInput("Search", "no_inputs");
        this.addOutput("Shop Found", "model,shop");
        this.addOutput("Shop Not Found", "");
        this.properties = {selected: '', modelProperties: window.triggerInfo.models['shop']}

        this.addWidget("combo","",'',(v) => {
            this.properties.selected = v;
            if(v !== '') {
                if(v === 'Search By Shop ID') {
                    this.title = 'Shop from ID';
                    this.inputs[0].name = 'Shop ID';
                    this.inputs[0].type = 'integer';
                    this.disconnectInput(0);
                } else if(v === 'Search By Partial Title') {
                    this.title = 'Shop from Partial Title';
                    this.inputs[0].name = 'Title Contains';
                    this.inputs[0].type = 'string';
                    this.disconnectInput(0);
                } else if(v === 'Search By Exact Title') {
                    this.title = 'Shop from Exact Title';
                    this.inputs[0].name = 'Title Is';
                    this.inputs[0].type = 'string';
                    this.disconnectInput(0);
                }
            } else {
                this.title = 'Dynamic Shop'
                this.inputs[0].name = 'Search';
                this.inputs[0].type = 'no_inputs';
                this.disconnectInput(0);
            }
            this.triggerSlot(0, v);
            this.triggerSlot(1, v);
        },{ property: "selected", values: ['Search By Shop ID', 'Search By Partial Title', 'Search By Exact Title'] } );


        this.bgcolor = '#ff7c69';
        this.title = 'Dynamic Shop';
        this.desc = 'Find a shop based on ID or Title';

    }
}

module.exports = Dynamic_Shop
